module.exports = __webpack_public_path__ + "static/media/file-doc.e6490986.svg";